import React, { useEffect } from 'react';
import './index.scss';
import { useDispatch, useSelector } from 'react-redux';
import Apple from '../../assets/logo/ic_apple.png';
import Android from '../../assets/logo/ic_android.png';
import Vortex from '../../assets/logo/logo_vortex_completo_invertido.png';
import Logo from '../../assets/logo/logo.png';
import { getInfo } from '../../redux/actions/infoGeneralActions';

const Footer = () => {
  const { infoGeneral } = useSelector((state) => state.infoReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!infoGeneral) {
      dispatch(getInfo());
    }
  }, []);
  return (
    <footer className="footer">
      <div className="container-footer">
        <div className="container-elements">
          <div className="container-download">
            <div className="download-app border-footer">
              <h5> Descargue nuestra aplicacion</h5>
              <div className="link-market">
                <a
                  href="https://itunes.apple.com/es/app/ceo-tucum%C3%A1n/id1245966662"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={Apple} alt="" width="25px" />
                  App Store
                </a>
              </div>
              <div className="link-market">
                <a
                  href="https://play.google.com/store/apps/details?id=ar.com.vortexsoftware.ceo"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={Android} alt="" width="25px" />
                  Play Store
                </a>
              </div>
            </div>
            <div className="created-by ">
              <p>Desarrollado por</p>
              <a
                href="http://www.vortexsoftware.com.ar/?utm_source=web&utm_campaign=centro_de_especialidades_oftalmologicas&utm_medium=footer"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Vortex} alt="" width="35%" />
              </a>
            </div>
          </div>
          <div className="container-contact border-footer ">
            <div className="container-tittle ">
              <img className="logo" src={Logo} alt="" width="25%" />
              <strong>Centro de Especialidades Oftalmológicas</strong>
            </div>
            <div className="container-direccion">
              <h5>Dirección </h5>
              <p>{infoGeneral?.direccion || 'Cargando...'}</p>
            </div>
            <div className="container-informacion">
              <h5>Contacto</h5>
              <div className="cuadrado">
                <ul>
                  {infoGeneral?.emails?.map((email) => (
                    <li key={email}>{email}</li>
                  ))}
                  {infoGeneral?.telefonos?.map((telefono) => (
                    <li key={telefono}>{telefono}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
